import { AxiosResponse } from 'axios'
import { axiosClient } from '@App/api/api-client'
import Pathes from '@App/dicts/pathes'
import { PermissionGroups, UserInfo } from '@Entities/user/user'
import { PaginationBodyUsers } from '@Entities/pagination'
import { ResultPage } from '@Entities/result-page'

export const getRightsholderUserToAbility = (
    rightsHolderId: number,
    userId: string
): Promise<AxiosResponse<UserInfo>> =>
    axiosClient.get<UserInfo>(Pathes.RightsHolder.rightsHolderUser(rightsHolderId, userId))

export const getRightsholderUsers = (
    rightsHolderId: number,
    pagination: Partial<PaginationBodyUsers>
): Promise<AxiosResponse<ResultPage<UserInfo>>> =>
    axiosClient.get<ResultPage<UserInfo>>(Pathes.RightsHolder.rightsHolderUsers(rightsHolderId, pagination))

export const getRightsholderUser = (rightsHolderId: number, userId: string): Promise<AxiosResponse<UserInfo>> =>
    axiosClient.get<UserInfo>(Pathes.RightsHolder.rightsHolderUser(rightsHolderId, userId))

export const editRightsholderUser = (
    rightsHolderId: number,
    userId: string,
    data: Array<Partial<PermissionGroups>>
): Promise<AxiosResponse<UserInfo>> =>
    axiosClient.patch<UserInfo>(Pathes.RightsHolder.rightsHolderUser(rightsHolderId, userId), data)

export const inviteRightsholderUser = (
    rightsHolderId: number,
    data: Partial<UserInfo>
): Promise<AxiosResponse<UserInfo>> =>
    axiosClient.post<UserInfo>(Pathes.RightsHolder.actionRightsHolderUser(rightsHolderId), data)

export const deleteRightsholderUser = (rightsHolderId: number, userId: string): Promise<AxiosResponse> =>
    axiosClient.delete(Pathes.RightsHolder.rightsHolderUser(rightsHolderId, userId))
